import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';
import { useRouter } from 'next/router';
import { parseQueryValue } from '@utils';
import {
  selectPrivateVehiclesPinnedFilters,
  togglePinnedFiltersState,
} from '@store';
import { useHasFilters } from 'hooks/common';
import { CUSTOMER_VEHICLES_MAPPER } from 'components/customerVehicles/constants';

export const useCustomerVehiclesFilterConfig = ({ enums }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectPrivateVehiclesPinnedFilters);
  const { hasFilters } = useHasFilters({ pinnedFilters });

  const filterCategories = useMemo(() => {
    if (!enums || enums?.length === 0) {
      return [];
    }

    return enums.categories?.map((category) => {
      return {
        id: category.id,
        label: CUSTOMER_VEHICLES_MAPPER[category.id]?.label || category.name,
        options: category.options,
        multiSelect: category.multiselect,
      };
    });
  }, [enums]);

  const currentFilters = useMemo(() => {
    const filters = {};

    if (!enums || enums?.length === 0 || isEmpty(router.query)) {
      return filters;
    }

    enums.categories?.forEach((category) => {
      const value = parseQueryValue(router.query[category.id]);

      if (isEmpty(value)) {
        return;
      }

      filters[category.id] = value;
    });

    return filters;
  }, [router.query, enums]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(
      togglePinnedFiltersState({ board: 'privateVehicles', pinnedFilter })
    );
  };
  return {
    supportPinnedFilters: true,
    filterCategories,
    currentFilters,
    pinnedFilters,
    hasFilters,
    handlePinnedFilterSelect,
  };
};
